// Registers /service-worker.js, generated at build time by workbox-cli
// (see workbox-config.js + the `postbuild` script in package.json — this
// file itself never ships to build/ until that step runs).
//
// `onUpdate(registration)` fires when a new service worker has finished
// installing and is waiting to take over (i.e. a new deploy landed while
// this tab was open). The caller is responsible for prompting the user and,
// on acceptance, posting {type: 'SKIP_WAITING'} to `registration.waiting`
// (see src/components/UpdateBanner.js) — we never force it automatically,
// since that would reload a visitor's tab out from under them mid-task.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d\d?)){3}$/)
);

export function register(config) {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return;
  }

  const publicUrl = new URL(process.env.PUBLIC_URL || '/', window.location.href);
  if (publicUrl.origin !== window.location.origin) {
    // A CDN-served PUBLIC_URL on a different origin can't register a SW
    // that controls this page's own origin.
    return;
  }

  // CRA's original template calls register() synchronously in index.js,
  // before React even renders, so gating on window's 'load' event made
  // sense there. This app calls register() from App.js's useEffect
  // instead — which by definition runs after mount, which is after 'load'
  // has already fired — so waiting for 'load' here would mean the
  // listener is attached after the event already passed and never fires.
  const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`;

  if (isLocalhost) {
    checkValidServiceWorker(swUrl, config);
  } else {
    registerValidSW(swUrl, config);
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (!installingWorker) return;

        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // A previous SW was already controlling this page, so this
              // install is an update, not the first-ever install.
              config?.onUpdate?.(registration);
            } else {
              config?.onSuccess?.(registration);
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('Service worker registration failed:', error);
    });

  // The new SW calls skipWaiting() only after the user opts in (see
  // UpdateBanner.js); once it does, `controllerchange` fires here and we
  // reload so the new version actually takes effect.
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => window.location.reload());
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('No internet connection found. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch((error) => console.error(error.message));
  }
}
